import { withProps } from 'recompose'
import { hasSocialMedia } from './utils'

const withCharitySocialMedia = withProps(({ charity }) => ({
  hasSocialMedia: charity && hasSocialMedia(charity),
  socialMedia: {
    facebook: charity && charity.facebook,
    twitter: charity && charity.twitter,
    instagram: charity && charity.instagram,
    google: charity && charity.googlePlus
  }
}))

export default withCharitySocialMedia



// WEBPACK FOOTER //
// ./src/services/charity/withCharitySocialMedia.js